<script>
    import { helperCommon } from "../../mixins/helper.common";
    export default {
        mixins: [ helperCommon ],
        props: {
            is_debug: {
                required: false,
                type: Boolean,
                default: false
            },
            init_selected_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_ignored_users: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_request_type: {
                required: false,
                type: String,
                default: 'account',
            },
            is_multiple: {
                required: false,
                type: Boolean,
                default: true,
            },
            options: {},
        },
        data() {
            return Object.assign(
                {
                    trans: {
                        'zh-HK': {
                            academic_year: '學年',
                            academic_section: '學制',
                            academic_level: '年級',
                            academic_class: '班別',
                            student: '學生',
                            parent: '家長/監護人帳戶',
                            please_select: '- 請選擇 -',
                            status: '狀態',
                            status_active: '啟動',
                            status_disable: '暫停',
                            user_type: '身份',
                            staff: '職員',
                            attendance_group: '組別',
                            language: '家中使用語言',
                            language_all: '所有',
                            language_chinese: '華語',
                            language_non_chinese: '非華語',
                            account_status: '用戶狀態',
                            student_status: '學生狀況',
                            student_status_in_attendance: '在園',
                            student_status_withdrawn: '退學',
                            student_status_graduated: '畢業',
                            student_status_new_student: '新生',
                            school_group_category: '小組類別',
                            school_group: '小組',
                            school_group_role: '小組身份',
                            group_member: '小組成員',
                            tuition_status: '學費設定紀錄',
                            have: '有',
                            not_have: '沒有',
                            non_chinese_speaking: '非華語',
                        },
                        'en': {
                            academic_year: 'Academic Year',
                            academic_section: 'Academic Section',
                            academic_level: 'Level',
                            academic_class: 'Class',
                            student: 'Student',
                            parent: 'Parent',
                            status: 'Status',
                            status_active: 'Active',
                            status_disable: 'Disable',
                            user_type: 'User Type',
                            staff: 'Staff',
                            attendance_group: 'Group',
                            language: 'Language at home',
                            language_all: 'All',
                            language_chinese: 'Chinese',
                            language_non_chinese: 'Non-Chinese',
                            account_status: 'Account status',
                            student_status: 'Student status',
                            student_status_in_attendance: 'Current Student',
                            student_status_withdrawn: 'Withdrawn',
                            student_status_graduated: 'Graduated',
                            student_status_new_student: 'New Student',
                            school_group_category: 'Group Category',
                            school_group: 'Group',
                            school_group_role: 'Group Role',
                            group_member: 'Group User',
                            tuition_status: 'Tuition Setting Record',
                            non_chinese_speaking: 'Non-Chinese Speaking',
                            'have': 'Have',
                            'not_have': 'Not Have',
                        }
                    },
                    selector_selected_users: this.init_selected_users,
                    selector_ignored_users: this.init_ignored_users,
                    request_type: this.init_request_type,
                    selector_user_options: [],
                    loading: false,
                    component_name: this.$options.name,
                    limit: 0,
                    filter_state: null,
                },
                __MIXIN__,
                { locale: window.locale }
            )
        },
        components: {},
        beforeMount() {
            this.destroySelector();
        },
        beforeDestroy() {
            this.destroySelector();
        },
        mounted() {
            let self = this;

            self.filter_state = 'init';
            if (self.is_debug) self.debugMessage('*** MOUNTED => [' + self.component_name + ']');
            this.debug_info();
            if (self.is_debug) this.debugMessage('[' + self.component_name + '] => ' + _.toLower(self.component_name) + '-initial-selector => on', 'gray');
            window.eventHub.$on(_.toLower(self.component_name) + '-initial-selector', (selected_users) => {
                self.filter_state = 'init';
                self.selector_selected_users = selected_users;
                if (self.is_debug) self.debugMessage('*** EVENT EMIT => [' + self.component_name + ']', 'success');
                self.debug_info('success');
                self.initialSelector();
            });

            // if (self.is_debug) this.debugMessage('[' + self.component_name + '] => ' + _.toLower(self.component_name) + '-update-selected-users => on', 'gray');
            // window.eventHub.$on(_.toLower(self.component_name) + '-update-selected-users', (selected_users) => {
            //     self.selector_selected_users = selected_users;
            //     if (self.is_debug) self.debugMessage('*** EVENT EMIT => [' + self.component_name + ']', 'success');
            //     self.debug_info('success');
            // });

            if (self.is_debug) this.debugMessage('[' + self.component_name + '] => ' + _.toLower(self.component_name) + '-update-ignored-users => on', 'gray');
            window.eventHub.$on(_.toLower(self.component_name) + '-update-ignored-users', (ignored_users) => {
                self.selector_ignored_users = ignored_users;
                if (self.is_debug) self.debugMessage('*** EVENT EMIT => [' + self.component_name + ']', 'success');
                self.debug_info('success');
            });

            if (self.is_debug) this.debugMessage('[' + self.component_name + '] => ' + _.toLower(self.component_name) + '-destroy-selector => on', 'gray');
            window.eventHub.$on(_.toLower(self.component_name) + '-destroy-selector', (selected_users) => {
                if (self.is_debug) self.debugMessage('*** EVENT EMIT => [' + self.component_name + ']', 'gray');
                self.debug_info('gray');

                self.destroySelector();
            });

            self.initialSelector();
        },
        watch: {
            init_selected_users: {
                handler(new_val) {
                    this.selector_selected_users = this.init_selected_users;
                },
                deep: true,
            },
            selector_selected_users: {
                handler(after, before) {
                    if (_.size(after) < _.size(before))
                    {
                        this.debug_info('error');
                    } else {
                        this.debug_info('info');
                    }
                    this.$nextTick(() => {
                        this.$emit('input', this.selector_selected_users);
                        window.eventHub.$emit('update-table-selected-users', this.selector_selected_users);
                    });
                },
                deep: true
            },
            selector_ignored_users: {
                handler(after, before) {
                    if (_.size(after) > 0) {
                        this.getUserOptions();
                    }
                },
                deep: true
            }
        },
        methods: {
            destroySelector() {
                let self = this;

                if (self.is_debug) self.debugMessage('*** BEFORE MOUNT => [' + self.component_name + ']', 'warning');
                self.debug_info('warning');
                window.eventHub.$off(_.toLower(self.component_name) + '-initial-selector');
                window.eventHub.$off(_.toLower(self.component_name) + '-update-selected-users');
                window.eventHub.$off(_.toLower(self.component_name) + '-update-ignored-users');
                window.eventHub.$off(_.toLower(self.component_name) + '-destroy-selector');
            },
            debug_info(color_type) {
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] : Selected users: ' + JSON.stringify(this.selector_selected_users), color_type);
                if (this.is_debug) this.debugMessage('[' + this.component_name + '] :' + ' Ignored users: ' + JSON.stringify(this.selector_ignored_users), color_type);
            },
            getOptions(url, method, successCallBack, failedCallBack) {
                this.filter_state = this.filter_state === 'init' ? 'init' : 'processing';
                this.loading = true;
                let self = this;

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function () {
                        self.loading = self.filter_state === 'init' || self.filter_state === 'processing';
                        successCallBack(response);
                    });
                };

                let ajaxFailCallback = (error) => {
                    self.filter_state = 'standby';
                    self.loading = false;
                    failedCallBack(error);
                };

                let option_url = url;
                this.$root.ajax_get(option_url, ajaxSuccessCallback, ajaxFailCallback, false);
            },
            postOptions(url, method, formdata, successCallBack, failedCallBack) {
                this.filter_state = this.filter_state === 'init' ? 'init' : 'processing';
                this.loading = true;
                let self = this;

                let ajaxSuccessCallback = (response) => {
                    self.$nextTick(function () {
                        self.loading = self.filter_state === 'init' || self.filter_state === 'processing';
                        successCallBack(response);
                    });
                };

                let ajaxFailCallback = (error) => {
                    self.filter_state = 'standby';
                    self.loading = false;
                    failedCallBack(error);
                };

                if(!_.isNull(formdata.filter_state) && !_.isUndefined(formdata.filter_state)) {
                    self.filter_state = formdata.filter_state;
                    delete formdata.filter_state;
                }

                let option_url = url;
                this.$root.ajax_call(option_url, method, formdata, ajaxSuccessCallback, ajaxFailCallback, false);
            },
            limitText(count) {
                if (this.is_multiple)
                {
                    return `${this.trans[this.locale].selectionLang.selected} (${count})`;
                } else {
                    return this.selector_selected_users.name;
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/UserPicker/UserSelector.vue